<template>
    <div class="plugin-home-invest-button">
        <div class="plugin-home-invest-button__wrap">
            <home-invest-button />
        </div>
    </div>

</template>

<script>
export default {
    name: 'plugin-home-invest-button',
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-invest-button {
    .container-landing();

    &__wrap {
        margin: 0 auto;
        max-width: 450px;
    }
    @media @media-md-down {
        &__wrap {
            max-width: 340px;
        }
    }
}
</style>
